"use client";

import { ApplicationType, ComponentBuilderClient, ComponentTemplate } from "@into-discovery/browsewebshared";
import { i18n } from "/i18n-config";
import { usePathname, useRouter } from "/navigation";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { useLocale } from "next-intl";
import { useSearchParams } from "next/navigation";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pageProps: any;
};

export default function MicrositeOrderedPageProvider({ pageProps }: Props) {
  const updatedData = useContentfulLiveUpdates(pageProps.data);
  const pathname = usePathname();
  const componentBuilderClient = new ComponentBuilderClient();
  const template = componentBuilderClient.getPageTemplate(updatedData, pageProps.appSettings, pageProps.pageType);
  const router = useRouter();
  const currentLocale = useLocale();
  const searchParams = useSearchParams();

  if (!template) {
    return null;
  }
  return (
    <ComponentTemplate
      template={template}
      pagePath={pathname}
      locales={i18n.locales}
      router={router}
      application={ApplicationType.UniBrandedB2c}
      currentLocale={currentLocale}
      searchParams={searchParams}
      applicationURL={pageProps.applicationURL}
    />
  );
}
